import getClassNames from "utils/getClassName";
import { CSSProperties } from "react";
import COLORS from "constants/Colors";
import styles from "./styles.module.scss";
import { ButtonProps } from "./types";

export default function Button({
  children,
  suffix,
  btnClassName = "",
  isOutline = false,
  color = "Primary700",
  onClick = (e: any) => {},
  type = "button",
  disabled = false,
  IconComponent,
}: ButtonProps) {
  const buttonClassName = getClassNames([
    "btn",
    `btn-${color}`,
    styles.customBtn,
    btnClassName,
  ]);

  const outlineExtraStyle: CSSProperties = {
    color: COLORS[color],
    borderColor: COLORS[color],
    backgroundColor: COLORS.Neutral0,
  };

  const solidExtraStyle: CSSProperties = {
    color: COLORS.Neutral0,
    borderColor: COLORS[color],
    backgroundColor: COLORS[color],
  };

  return (
    <button
      style={isOutline ? outlineExtraStyle : solidExtraStyle}
      className={buttonClassName}
      type={type}
      onClick={onClick}
      disabled={disabled}
    >
      {!!IconComponent && (
        <div className="d-flex justify-content-center align-items-center">
          {IconComponent}
        </div>
      )}
      {children}
      {!!suffix && (
        <div className="d-flex justify-content-center align-items-center">
          {suffix}
        </div>
      )}
    </button>
  );
}
